import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// ----- Public
export const getMatches = (game) =>
  API.get("/matches", { params: { game } }).then((r) => r.data);

export const getTeams = (game) =>
  API.get("/teams", { params: { game } }).then((r) => r.data);

export const getStreaming = (game) =>
  API.get(`/streaming/${game}`).then((r) => r.data);

export const getAllStreaming = () => API.get("/streaming").then((r) => r.data);

// ----- Auth
export const login = (email, password) =>
  API.post("/auth/login", { email, password }).then((r) => r.data);

export const logout = () => API.post("/auth/logout").then((r) => r.data);

export const me = () => API.get("/auth/me").then((r) => r.data);

// ----- Admin
export const updateMatch = (id, payload) =>
  API.patch(`/admin/matches/${id}`, payload).then((r) => r.data);

export const createTeam = (payload) =>
  API.post("/admin/teams", payload).then((r) => r.data);

export const deleteTeam = (id) =>
  API.delete(`/admin/teams/${id}`).then((r) => r.data);

export const upsertStreaming = (game, payload) =>
  API.put(`/admin/streaming/${game}`, payload).then((r) => r.data);

export const GAME_META = {
  fc25: {
    key: "fc25",
    name: "EA SPORTS FC 25",
    short: "FC 25",
    modality: "consola",
    platform: "PlayStation",
    accent: "#22D3EE",
    description:
      "1 contra 1, encontro clássico, equipas masculinas reais. 32 equipas em eliminatórias do tipo Copa: dos 32-avos de Final até à grande Final.",
  },
  fortnite: {
    key: "fortnite",
    name: "Fortnite",
    short: "Fortnite",
    modality: "pc",
    platform: "PC",
    accent: "#A78BFA",
    description:
      "Construção e gunfights ao mais alto nível. Joga-se em equipas de 2 (duos). Eliminatórias dos Quartos até à Final.",
    format: "Duos · 2 jogadores por equipa",
  },
  freefire: {
    key: "freefire",
    name: "Free Fire",
    short: "Free Fire",
    modality: "mobile",
    platform: "Mobile",
    accent: "#F97316",
    description:
      "Battle Royale rápido para telemóvel. Esquadrões enfrentam-se em rondas eliminatórias.",
  },
  codmobile: {
    key: "codmobile",
    name: "Call of Duty: Mobile",
    short: "COD Mobile",
    modality: "mobile",
    platform: "Mobile",
    accent: "#22C55E",
    description:
      "Multiplayer tático para telemóvel. Eliminatórias diretas até à Final.",
  },
};

export const MODALITY_META = {
  mobile: {
    title: "Mobile",
    subtitle: "Free Fire · COD Mobile",
    games: ["freefire", "codmobile"],
    image:
      "https://images.pexels.com/photos/7773745/pexels-photo-7773745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  pc: {
    title: "PC",
    subtitle: "Fortnite",
    games: ["fortnite"],
    image:
      "https://images.pexels.com/photos/15870664/pexels-photo-15870664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  consola: {
    title: "Consola",
    subtitle: "EA SPORTS FC 25",
    games: ["fc25"],
    image:
      "https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MTJ8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjBzdGFkaXVtJTIwbmlnaHR8ZW58MHx8fHwxNzgxODY3NDc0fDA&ixlib=rb-4.1.0&q=85",
  },
};

export const ROUND_LABEL = {
  R32: "32-avos de Final",
  R16: "Oitavos de Final",
  QF: "Quartos de Final",
  SF: "Meias-Finais",
  F: "Final",
};
